import React from 'react';
import ReactDOM from 'react-dom/client';
import { initCaseStudyMap } from './map/case-study-map';
import { initTextColorReveal } from './animations/text-color-reveal';
import { initPixelCursorTrail } from './animations/pixel-cursor-trail';
import { initWordCascadeRight } from './animations/word-cascade-right';
import { initCaseStudyMosaicScroll } from './animations/case-study-mosaic-scroll';
import { initMasonry } from './layout/masonry';
import { themeColor } from './utils/theme-color';

const caseStudyMapContainer = document.getElementById( 'caseStudyMap' );

if ( caseStudyMapContainer && window.tedCaseStudyMap ) {
	initCaseStudyMap( caseStudyMapContainer, window.tedCaseStudyMap );
}

const introStatementContainer = document.getElementById( 'introStatement' );

if ( introStatementContainer ) {
	initTextColorReveal( introStatementContainer );
	// bg-blue section → cream tail.
	initPixelCursorTrail(
		introStatementContainer,
		themeColor( '--color-cream', '#efe7d6' )
	);
}

const heroSection = document.getElementById( 'heroSection' );

if ( heroSection ) {
	initPixelCursorTrail(
		heroSection,
		themeColor( '--color-blue', '#40569d' )
	);
}

const housingStatementSection = document.getElementById( 'housingStatement' );

if ( housingStatementSection ) {
	initWordCascadeRight( housingStatementSection );
	// bg-green section → orange tail.
	initPixelCursorTrail(
		housingStatementSection,
		themeColor( '--color-orange', '#e3572a' )
	);
}

const caseStudyMosaicSection = document.getElementById( 'caseStudyMosaic' );

if ( caseStudyMosaicSection ) {
	initCaseStudyMosaicScroll( caseStudyMosaicSection );
	// bg-orange section → brown tail.
	initPixelCursorTrail(
		caseStudyMosaicSection,
		themeColor( '--color-brown', '#2e170e' )
	);
}

const eventsListSection = document.getElementById( 'eventsList' );

if ( eventsListSection ) {
	// bg-orange section → brown tail.
	initPixelCursorTrail(
		eventsListSection,
		themeColor( '--color-brown', '#2e170e' )
	);
}

document.querySelectorAll( '[data-layout="masonry"]' ).forEach( initMasonry );
